import React, { Component ,useState,useEffect} from 'react';
// import cloneDeep from "lodash/cloneDeep";
// import throttle from "lodash/throttle";
// import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import '../../../DataTable.css';

function ReportTable() {

    // const tableHead = {
    //     id: "SlNo",
    //     category_name: "Category",
    //     name: "Sub Category",

    //   };
    // const allData = [
    //     {
    //       name: "Sale",
    //       parentId: "12",
    //       campaignType: "Push",
    //       action: ":"
    //     },
    //     {
    //       name: "Sale2",
    //       parentId: "123",
    //       campaignType: "Inapp",
    //       action: ":"
    //     },

    //   ];

      const itemsPerPage  = 10;
      const [data, setAllData] = useState([]);
      const [currentPage, setCurrentPage] = useState(1);

    // Calculate total number of pages
    const totalPages = Math.ceil(data.length / itemsPerPage);

    // Calculate start and end index of current page
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    // Get current page data
    const currentData = data.slice(startIndex, endIndex);

    // Function to handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const getPageNumbers = () => {
        if (totalPages <= 8) return Array.from({ length: totalPages }, (_, i) => i + 1);
        const pages = [];
        let start = Math.max(1, currentPage - 2);
        let end = start + 5;
        if (end >= totalPages - 1) {
            end = totalPages;
            start = Math.max(1, end - 5);
        }
        // Show first 2 pages if window doesn't start from 1
        if (start > 2) {
            pages.push(1);
            pages.push(2);
            pages.push('...');
        } else if (start === 2) {
            pages.push(1);
        }
        for (let i = start; i <= end; i++) {
            if (!pages.includes(i)) pages.push(i);
        }
        // Show last 2 pages if window doesn't reach end
        if (end < totalPages - 1) {
            pages.push('...');
            pages.push(totalPages - 1);
            pages.push(totalPages);
        } else if (end === totalPages - 1) {
            pages.push(totalPages);
        }
        return pages;
    };
    //   const [value, setValue] = React.useState("");
    //   const [currentPage, setCurrentPage] = React.useState(1);
    //   const [collection, setCollection] = React.useState(
    //     cloneDeep(allData.slice(0, countPerPage))
    //   );
    //   const searchData = React.useRef(
    //     throttle(val => {
    //       const query = val.toLowerCase();
    //       setCurrentPage(1);
    //       const data = cloneDeep(
    //         allData
    //           .filter(item => item.name.toLowerCase().indexOf(query) > -1)
    //           .slice(0, countPerPage)
    //       );
    //       setCollection(data);
    //     }, 400)
    //   );
    
    useEffect(() => {
        loadcategory();
        // if (!value) {
        //   updatePage(1);
        // } else {
        //   searchData.current(value);
        // }
      }, []);
    


      const loadcategory=()=>{
        fetch("https://api.novetheitaliankitchen.in/index.php/Api/users", {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
              //"Content-type": "application/json; charset=UTF-8",
            },
          })
            .then((res) => res.json())
            .then((result) => {
              //console.log(result);
              if (result.data != "") {
                const data = result.data;
                setAllData(data);
              }
            })
          .catch((err) => {
            console.log(err.message);
          });
        }

 
        return (
            <div className="col-12">
                <div className="ms-panel">
                    <div className="ms-panel-header">
                       
                        <div class="container">
                          <div class="row">
                              <div class="col-md-10">
                              <h6>Users Report</h6>
                              </div>
                             
                          </div>
                      </div>
                    </div>
                    <div className="ms-panel-body">
                        <div className="table-responsive1">
                      
                            <table className="table table-hover thead-primary" >
                                <thead>
                                <tr >
                                    <td >User Name</td>
                                    <td >Email</td>
                                    <td >Phone Number</td>
                                    <td >Date</td>
                                </tr>
                                </thead>
                                {currentData.map((data, i) => (
                                    <tr key={i}>
                                    <td >{data.user_name}</td>
                                    <td >{data.email}</td>
                                    <td >{data.phone_number}</td>
                                    <td >{data.date}</td>
                                    </tr>
                                    ))}
                            </table>

                            <div className="pagination-container">
                            <button className="paginationCategory" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                                Previous
                            </button>
                            {getPageNumbers().map((page, index) => (
                                page === '...' ? (
                                    <span key={index} className="paginationCategory pagination-ellipsis">...</span>
                                ) : (
                                    <button key={index} className={`paginationCategory ${currentPage === page ? 'active' : ''}`} onClick={() => handlePageChange(page)}>
                                        {page}
                                    </button>
                                )
                            ))}
                            <button className="paginationCategory" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                                Next
                            </button>
                        </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        );

}

export default ReportTable;